export const EndPoints = {
  RESET_PASSWORD: {
    FRANCHISE_UPDATE: "lims/master/reset_password/franchisemaster",
    EMPLOYEE_UPDATE: "hrms/master/reset_password/employee",
  },
  PatientGraph: {
    GRAPHSTATSLIST: "reports/dashboard/stats",
    PATIENTLIST: "reports/dashboard/patient_graph",
    HEADER_DETAILS: "limsdashboard/header/details",
  },
  EmployeeCatergory: {
    LIST: "hrms/employees/category/dropdown",
  },
  City: {
    LIST: "lims/city/master",
  },
  Franchise: {
    CREATE: "lims/create/franchise/master",
    LIST: "lims/franchise_master/master/list",
    ONLY_PARENT_FRANCHISE_LIST:
      "lims/franchise_master/master/ony_parent_franchise_dd",
    LIST_DD: "lims/franchise_master/master/franchise_dd",
    LIST_BY_ID: "lims/master/list/franchisemaster_by_id",
    EXISTS_USERNAME: "hrms/master/employee/exists_username/",
    EXISTS_EMAIL: "lims/master/franchise/exists_email/",
    UPDATE: "lims/master/update/franchisemaster",
    DELETE: "lims/master/delete/franchisemaster",
    DOWNLOAD_CSV: "lims/master/franchisemaster/downloadcsv",
    ALLOT_BARCODE: "lims/franchise/allot_barcodes",
    ONBOARDING: "lims/master/create/frachise_onboarding",
    ONBOARDING_LIST: "lims/master/list/frachise_onboarding",
    ONBOARDING_PENDING: "lims/master/pending/frachise_onboarding",
    ONBOARDING_APPROVE: "lims/master/approve/frachise_onboarding",
    ONBOARDING_REJECT: "lims/master/reject/frachise_onboarding",
    LIST_WITH_STATISTICS: "lims/master/franchisemaster/list_with_statistics",
    ZONE_LIST_WITH_STATISTICS: "lims/master/franchisemaster/zone_list_with_statistics",
    STATISTICS_MARKETING_PERSONS:
      "lims/master/franchisemaster/statistics/marketing_persons",
  },
  ApprovedOnboardingReport: {
    LIST: "reports/onboarding/approved/data",
    MARKETING_PERSONS: "reports/onboarding/approved/marketing_persons",
  },
  PackageInvestigationMaster: {
    CREATE: "lims/master/create/packageinvestigationmaster",
    LIST: "lims/master/list/packageinvestigationmaster",
    UPDATE: "lims/master/update/packageinvestigationmaster",
    DELETE: "lims/master/delete/packageinvestigationmaster",
    DOWNLOAD_CSV: "lims/master/packageinvestigationmaster/downloadcsv",
  },
  PatientReceipt: {
    LIST: "lims/master/list/patientappointment_full_detail",
  },
  PatientSettlement: {
    CREATE:
      "lims/master/create/capture_patient_appointment_balance_payment",
  },
  PatientAppointmentDetails: {
    CREATE: "lims/master/create/patientappointmentdetail",
    LIST: "lims/master/list/patientappointmentdetail",
    UPDATE: "lims/master/update/patientappointmentdetail",
    DELETE: "lims/master/delete/patientappointmentdetail",
    CANCEL: "lims/master/cancel/patient_appointment",
    CANCELLATION_HISTORY:
      "lims/master/list/patient_appointment_cancellation_history",
    DOWNLOAD_CSV: "lims/master/patientappointmentdetail/downloadcsv",
    CHANGE_FRANCHISE:
      "lims/master/update/patientappointment/change_franchise",
    CHANGE_BARCODE: "lims/master/update/patientappointment/change_barcode",
    CHANGE_ZONE: "lims/master/update/patientappointment/change_zone",
    GET_SAMPLEWISE_BARCODE:
      "lims/master/get/patientappointment/get_samplewise_barcode",
  },
  PackageInvestigation: {
    CREATE: "lims/master/create/packageinvestigation",
    PACKAGELIST: "lims/master/list/investigation/",
    LIST: "lims/master/list/packagemaster",
    UPDATE: "lims/master/update/packagemaster",
    DELETE: "lims/master/delete/packagemaster",
    DOWNLOAD_CSV: "lims/master/packagemaster/downloadcsv",
  },
  InvestigationSequence: {
    CREATE: "lims/master/create/investigation_sequencemaster",
    BULKUPDATE: "lims/master/bulkupdate/investigation_sequencemaster",
    LIST: "lims/master/list/all_investigation_list",
    SEQUENCE: "lims/master/list/investigation_sequencemaster",
    UPDATE: "lims/master/update/investigation_sequencemaster",
    DELETE: "lims/master/delete/investigation_sequencemaster",
    DOWNLOAD_CSV: "lims/master/investigation_sequencemaster/downloadcsv",
  },
  InvestigationObservation: {
    CREATE: "lims/master/create/investigation_observationmaster",
    LIST: "lims/master/list/investigation_observationmaster",
    MULTIPLEOBSERVATIONlIST: "lims/master/list/observationmaster_dd",
    UPDATE: "lims/master/update/investigation_observationmaster",
    DELETE: "lims/master/delete/investigation_observationmaster",
    DOWNLOAD_CSV: "lims/master/investigation_observationmaster/downloadcsv",
  },
  Organism: {
    CREATE: "lims/master/create/organismmaster",
    LIST: "lims/master/list/organismmaster",
    UPDATE: "lims/master/update/organismmaster",
    DELETE: "lims/master/delete/organismmaster",
    DOWNLOAD_CSV: "lims/master/organismmaster/downloadcsv",
  },
  DoctorsSepcialization: {
    CREATE: "lims/master/create/doctor_specializationmaster",
    LIST: "lims/master/list/doctor_specializationmaster",
    UPDATE: "lims/master/update/doctor_specializationmaster",
    DELETE: "lims/master/delete/doctor_specializationmaster",
    DOWNLOAD_CSV: "lims/master/doctor_specializationmaster/downloadcsv",
  },
  DoctorsDegree: {
    CREATE: "lims/master/create/doctor_degreemaster",
    LIST: "lims/master/list/doctor_degreemaster",
    UPDATE: "lims/master/update/doctor_degreemaster",
    DELETE: "lims/master/delete/doctor_degreemaster",
    DOWNLOAD_CSV: "lims/master/doctor_degreemaster/downloadcsv",
  },
  DiscountReason: {
    CREATE: "lims/master/create/discount_reasonmaster",
    LIST: "lims/master/list/discount_reasonmaster",
    UPDATE: "lims/master/update/discount_reasonmaster",
    DELETE: "lims/master/delete/discount_reasonmaster",
    DOWNLOAD_CSV: "lims/master/discount_reasonmaster/downloadcsv",
  },
  FranchiseType: {
    CREATE: "lims/master/create/franchisetypes",
    LIST: "lims/master/list/franchisetypes",
    UPDATE: "lims/master/update/franchisetypes",
    DELETE: "lims/master/delete/franchisetypes",
    DOWNLOAD_CSV: "lims/master/franchisetypes/downloadcsv",
  },
  DepartmentType: {
    CREATE: "lims/master/create/departmenttypemaster",
    LIST: "lims/master/list/departmenttypemaster",
    UPDATE: "lims/master/update/departmenttypemaster",
    DELETE: "lims/master/delete/departmenttypemaster",
    DOWNLOAD_CSV: "lims/master/departmenttypemaster/downloadcsv",
  },
  LabDepartment: {
    CREATE: "lims/master/create/labdepartmentmaster",
    LIST: "lims/master/list/labdepartmentmaster",
    UPDATE: "lims/master/update/labdepartmentmaster",
    DELETE: "lims/master/delete/labdepartmentmaster",
    DOWNLOAD_CSV: "lims/master/labdepartmentmaster/downloadcsv",
  },
  CollectionType: {
    CREATE: "lims/master/create/collectiontypemaster",
    LIST: "lims/master/list/collectiontypemaster",
    UPDATE: "lims/master/update/collectiontypemaster",
    DELETE: "lims/master/delete/collectiontypemaster",
    DOWNLOAD_CSV: "lims/master/collectiontypemaster/downloadcsv",
  },
  Circular: {
    CREATE: "lims/master/create/circularmaster",
    LIST: "lims/master/list/circularmaster",
    UPDATE: "lims/master/update/circularmaster",
    DELETE: "lims/master/delete/circularmaster",
    DOWNLOAD_CSV: "lims/master/circularmaster/downloadcsv",
  },
  BRANCH: {
    CREATE: "hrms/master/create/branch",
    LIST: "hrms/master/list/branch",
    UPDATE: "hrms/master/update/branch",
    DELETE: "hrms/master/delete/branch",
    DOWNLOAD_CSV: "hrms/master/branch/downloadcsv",
  },
  Zone: {
    CREATE: "lims/master/create/zone",
    LIST: "lims/zone/master",
    LIST_BY_ID: "lims/master/list/zonemaster/zone_detail",
    UPDATE: "lims/master/update/zonemaster",
    DELETE: "lims/master/delete/zonemaster",
    DOWNLOAD_CSV: "lims/master/zonemaster/downloadcsv",
    COPY_OBSERVATIONS: "lims/master/copy/zone_observations",
  },
  Area: {
    CREATE: "lims/master/create/areamaster",
    LIST: "lims/master/list/areamaster",
    UPDATE: "lims/master/update/areamaster",
    DELETE: "lims/master/delete/areamaster",
    DOWNLOAD_CSV: "lims/master/areamaster/downloadcsv",
  },
  // CREATEDEPARTMENT: "hrms/master/create/department",
  // CREATEBRANCH: "hrms/master/create/branch",
  // STATEBYCOUNTRY: "lims/get_state/",
  // CITYBYSTATE: "lims/get_city/",
  // ZONELIST: "lims/zone/master",
  ZONELISTDD: "lims/zone/master/zone_dd",
  // CREATEROLE: "hrms/master/create/roles",
  // CREATEDESIGNATION: "hrms/master/create/designation",
  // GETDEPARTMENT: "hrms/master/list/department",
  // PANELTYPEMASTER: "lims/master/create/franchisetypes",
  // ADDZONEMASTER: "lims/master/create/zone",
  // ADDAREAMASTER: "lims/master/create/areamaster",
  // ADDCIRUCLARMASTER: "lims/master/create/circularmaster",
  // DISCOUNTMASTER: "lims/master/create/discount_reasonmaster",
  // DOCTORMASTER: "lims/master/create/doctor_degreemaster",
  // DOCTORSPECIALIZATION: "lims/master/create/doctor_specializationmaster",
  // BRANCHLISTING: "hrms/master/list/branch/",
  // DELETEBRANCH: "hrms/master/delete/branch/",
  SAMPLESTATUS: "lims/master/list/appointmentstatusmaster",
  DEPARTMENT: {
    CREATE: "hrms/master/create/department",
    LIST: "hrms/master/list/department",
    UPDATE: "hrms/master/update/department",
    DELETE: "hrms/master/delete/department",
    DOWNLOAD_CSV: "hrms/master/department/downloadcsv",
  },
  DESIGNATION: {
    CREATE: "hrms/master/create/designation",
    LIST: "hrms/master/list/designation",
    UPDATE: "hrms/master/update/designation",
    DELETE: "hrms/master/delete/designation",
    DOWNLOAD_CSV: "hrms/master/designation/downloadcsv",
  },
  EMPLOYEE: {
    CREATE: "hrms/master/create/employee",
    LIST: "hrms/master/list/employee",
    UPDATE: "hrms/master/update/employee",
    DELETE: "hrms/master/delete/employee",
    DOWNLOAD_CSV: "hrms/master/employee/downloadcsv",
    EXISTS_USERNAME: "hrms/master/employee/exists_username/",
    EXISTS_EMAIL: "hrms/master/employee/exists_email/",
  },
  EMPLOYEETYPE: {
    CREATE: "hrms/master/create/employeetypes",
    LIST: "hrms/master/list/employeetypes",
    UPDATE: "hrms/master/update/employeetypes",
    DELETE: "hrms/master/delete/employeetypes",
    DOWNLOAD_CSV: "hrms/master/employeetypes/downloadcsv",
  },
  EMPLOYEECATEGORY: {
    CREATES: "hrms/master/create/employeecategory",
    CREATE: "hrms/master/create/employeecategorymaster",
    LIST: "hrms/master/list/employeecategorymaster",
    UPDATE: "hrms/master/update/employeecategorymaster",
    DELETE: "hrms/master/delete/employeecategorymaster",
    DOWNLOAD_CSV: "hrms/master/employeecategorymaster/downloadcsv",
  },
  DISCOUNTREASON: {
    CREATE: "lims/master/create/discount_reasonmaster",
    LIST: "lims/master/list/discount_reasonmaster",
    UPDATE: "lims/master/update/discount_reasonmaster",
    DELETE: "lims/master/delete/discount_reasonmaster",
    DOWNLOAD_CSV: "lims/master/discount_reasonmaster/downloadcsv",
  },
  PAYMENTMODE: {
    CREATE: "accounts/master/create/paymentmodemaster",
    LIST: "accounts/master/list/paymentmodemaster",
    UPDATE: "accounts/master/update/paymentmodemaster",
    DELETE: "accounts/master/delete/paymentmodemaster",
    DOWNLOAD_CSV: "accounts/master/paymentmodemaster/downloadcsv",
  },
  ADVANCEPAYMENT: {
    CREATE: "accounts/master/create/franchiseadvancepaymentmaster",
    UPDATE: "accounts/master/update/franchiseadvancepaymentmaster",
    BULK_UPDATE: "accounts/master/bulkupdate/franchiseadvancepaymentmaster",
    LIST: "accounts/master/list/franchiseadvancepaymentmaster",
    DELETE: "accounts/master/delete/franchiseadvancepaymentmaster",
    DOWNLOAD_CSV: "accounts/master/franchiseadvancepaymentmaster/downloadcsv",
  },
  ROLE: {
    CREATE: "hrms/master/create/roles",
    LIST: "hrms/master/list/roles",
    UPDATE: "hrms/master/update/roles/",
    DELETE: "hrms/master/delete/roles",
    DOWNLOAD_CSV: "hrms/master/roles/downloadcsv",
  },
  SECTION: {
    CREATE: "hrms/master/create/navbar_section_master",
    LIST: "hrms/master/list/navbar_section_master",
    UPDATE: "hrms/master/update/navbar_section_master/",
    DELETE: "hrms/master/delete/navbar_section_master",
    DOWNLOAD_CSV: "hrms/master/navbar_section_master/downloadcsv",
  },
  ROLES_SECTION: {
    LIST_BY_ROLE: "hrms/master/list/roles_section_master",
    CREATE: "hrms/master/create/roles_section_master",
    DELETE: "hrms/master/delete/roles_section_master",
  },
  DOCUMENT: {
    CREATE: "lims/master/create/documentmaster",
    LIST: "lims/master/list/documentmaster",
    UPDATE: "lims/master/update/documentmaster",
    DELETE: "lims/master/delete/documentmaster",
    DOWNLOAD_CSV: "lims/master/documentmaster/downloadcsv",
  },
  SAMPLECOLLECTION: {
    LIST: "lims/master/sample/list",
    CREATE: "lims/master/sample/mark_collect_and_received",
    MACHINE_CREATE: "lims/master/sample/print_sample_label_for_machine",
    SAMPLEINFORMATION: "lims/new/registration/get_registration_detail",
  },
  SHARETYPE: {
    CREATE: "lims/master/create/sharetypemaster",
    LIST: "lims/master/list/sharetypemaster",
    UPDATE: "lims/master/update/sharetypemaster",
    DELETE: "lims/master/delete/sharetypemaster",
    DOWNLOAD_CSV: "lims/master/sharetypemaster/downloadcsv",
  },
  SAMPLETYPE: {
    CREATE: "lims/master/create/sampletypemaster",
    LIST: "lims/master/list/sampletypemaster",
    UPDATE: "lims/master/update/sampletypemaster",
    DELETE: "lims/master/delete/sampletypemaster",
    DOWNLOAD_CSV: "lims/master/sampletypemaster/downloadcsv",
    UPLOAD_VOIL_IMAGE: "lims/master/sampletypemaster/upload_voil_image",
    GET_VOIL_IMAGE: "lims/master/sampletypemaster/download_voil_image",
  },
  SAMPLEREJECTIONREASON: {
    CREATE: "lims/master/create/samplerejectionreasonmaster",
    LIST: "lims/master/list/samplerejectionreasonmaster",
    UPDATE: "lims/master/update/samplerejectionreasonmaster",
    DELETE: "lims/master/delete/samplerejectionreasonmaster",
    DOWNLOAD_CSV: "lims/master/samplerejectionreasonmaster/downloadcsv",
  },
  PAYMENTTYPE: {
    CREATE: "accounts/master/create/paymenttypemaster",
    LIST: "accounts/master/list/paymenttypemaster",
    UPDATE: "accounts/master/update/paymenttypemaster",
    DELETE: "accounts/master/delete/paymenttypemaster",
    DOWNLOAD_CSV: "accounts/master/paymenttypemaster/downloadcsv",
  },
  INVESTIGATIONTEST: {
    CREATE: "lims/master/create/investigationmaster",
    LIST: "lims/master/list/investigationmaster",
    LIST_DD: "lims/master/list/investigationmaster_dd",
    UPDATE: "lims/master/update/investigationmaster",
    DELETE: "lims/master/delete/investigationmaster",
    DOWNLOAD_CSV: "lims/master/investigationmaster/downloadcsv",
  },
  INVESTIGATIONMANAGER: {
    CREATEHELPMENULIST: "lims/master/create/investigation_helpmaster",
    CREATEINVESTIGATIONINTERPRETATIONLIST:
      "lims/master/create/investigation_ineterpretationmaster",
    CREATEOBSERVATIONLIST:
      "lims/master/bulkcreate/investigation_observationmaster",
    OBSERVATIONLIST: "lims/master/list/observationmaster_dd",
    CREATE: "lims/create/full/investigationmaster",
    CREATEINVESTIGATIONLIST:
      "lims/master/create/investigation_commentmaster",
    LIST: "lims/master/list/investigationmaster",
    UPDATE: "lims/master/update/fullinvestigationmaster",
    DELETE: "lims/master/delete/investigationmaster",
    DOWNLOAD_CSV: "lims/master/investigationmaster/downloadcsv",
    INVESTIGATION_OBSERVATION_LIST:
      "lims/master/list/investigation_observationmaster",
    UPDATE_INVESTIGATION_OBSERVATION_LIST:
      "lims/master/bulkupdate/observationmaster_only/",
    DELETE_INVESTIGATION_OBSERVATION_LIST:
      "lims/master/delete/investigation_observationmaster",
    INVESTIGATION_COMMENT_LIST:
      "lims/master/list/investigation_commentmaster",
    INVESTIGATION_INTERPRETATION_LIST:
      "lims/master/list/investigation_ineterpretationmaster",
    INVESTIGATION_HELP_MENU_LIST:
      "lims/master/list/investigation_helpmaster",
    INVESTIGATION_OBSERVATION_RANGES_LIST:
      "lims/master/list/investigation_observations_and_ranges",
    UPDATE_INVESTIGATION_OBSERVATION_SEQUENCE:
      "lims/master/bulkupdate/investigation_observation_sequence/",
    SHOW_DUMMY_REPORT_DATA:
      "lims/list/full_investigation/show_dummy_data_for_sample_pdf",
  },
  INVESTIGATION_OBSERVATION_FORMULA: {
    CREATE: "lims/master/create/observationformula",
    UPDATE: "lims/master/update/observationformula",
    LIST: "lims/master/list/observationformula",
    DELETE: "lims/master/delete/observationformula",
  },
  INVESTIGATIONTEMPLATE: {
    CREATE: "lims/master/create/investigation_templatemaster",
    LIST: "lims/master/list/investigation_templatemaster",
    LIST_BY_ID: "lims/master/list/investigation_templatemaster",
    UPDATE: "lims/master/update/investigation_templatemaster",
    DELETE: "lims/master/delete/investigation_templatemaster",
    DOWNLOAD_CSV: "lims/master/investigation_templatemaster/downloadcsv",
  },
  EMPDISCOUNTALLOWED: {
    CREATE: "lims/master/create/employee_discount_allowedmaster",
    LIST: "lims/master/list/employee_discount_allowedmaster",
    UPDATE: "lims/master/update/employee_discount_allowedmaster",
    DELETE: "lims/master/delete/employee_discount_allowedmaster",
    DOWNLOAD_CSV: "lims/master/employee_discount_allowedmaster/downloadcsv",
  },
  INVESTIGATIONNABL: {
    CREATE: "lims/master/create/investigation_nablmaster",
    LIST: "lims/master/list/investigation_nablmaster",
    UPDATE: "lims/master/update/investigation_nablmaster",
    DELETE: "lims/master/delete/investigation_nablmaster",
    DOWNLOAD_CSV: "lims/master/investigation_nablmaster/downloadcsv",
  },
  OUTSOURCEINVESTIGATION: {
    CREATE: "lims/master/create/outsource_investigationmaster",
    LIST: "lims/master/list/outsource_investigationmaster",
    UPDATE: "lims/master/update/outsource_investigationmaster",
    DELETE: "lims/master/delete/outsource_investigationmaster",
    DOWNLOAD_CSV: "lims/master/outsource_investigationmaster/downloadcsv",
  },
  OUTSOURCELAB: {
    CREATE: "lims/master/create/outsource_labmaster",
    LIST: "lims/master/list/outsource_labmaster",
    UPDATE: "lims/master/update/outsource_labmaster",
    DELETE: "lims/master/delete/outsource_labmaster",
    DOWNLOAD_CSV: "lims/master/outsource_labmaster/downloadcsv",
  },
  PACKAGE: {
    CREATE: "lims/master/create/packageinvestigation",
    LIST: "lims/master/list/packagemaster",
    LIST_BY_ID: "lims/master/list/packagemaster",
    UPDATE: "lims/master/update/packagemaster",
    UPDATE_ALL: "lims/master/update/packagemaster_all",
    BULK_UPDATE: "lims/master/bulkupdate/packagemaster_cost",
    DELETE: "lims/master/delete/packagemaster",
    INVESTIGATION_DELETE: "lims/master/delete/packageinvestigationmaster",
    DOWNLOAD_CSV: "lims/master/packagemaster/downloadcsv",
  },
  TESTRATE: {
    CREATE: "lims/master/create/test_ratemaster",
    LIST: "lims/master/list/test_ratemaster",
    UPDATE: "lims/master/update/test_ratemaster",
    DELETE: "lims/master/delete/test_ratemaster",
    DOWNLOAD_CSV: "lims/master/test_ratemaster/downloadcsv",
    DOWNLOAD_CSV_GENERATE_TEMPLATE:
      "lims/master/test_ratemaster/generate_csv_template",
    UPLOAD_TEST_RATE_CSV:
      "lims/master/test_ratemaster/upload_test_rate_csv",
    COPY_RATES: "lims/copy/rate/list",
  },
  PANELMASTER: {
    CREATE: "lims/master/create/test_ratemaster",
    LIST: "lims/master/list/panel_wise_test_ratemaster",
    LIMS_FRANCHISE_COPY_RATE_LIST:
      "lims/master/list/lims/panel_wise_test_ratemaster",
    FRANCHISE_INVESTIGATION_DETAILS: "lims/show/investigation/all_detail",
    PENDING_LIST: "lims/get/pending/rate",
    UPDATE: "lims/master/update/bulk_update_test_ratemaster",
    LIMS_UPDATE:
      "lims/master/lims/update/bulk_update_test_ratemaster",
    DELETE: "lims/master/delete/test_ratemaster",
    DOWNLOAD_CSV: "lims/master/test_ratemaster/downloadcsv",
    COPY_RATES: "lims/copy/rate/list",
    SYNC: "lims/master/franchisemaster/sync_all_investigations_to_test_rate_master",
  },
  INVESTIGATIONHELP: {
    CREATE: "lims/master/create/investigation_helpmaster",
    LIST: "lims/master/list/investigation_helpmaster",
    UPDATE: "lims/master/update/investigation_helpmaster",
    DELETE: "lims/master/delete/investigation_helpmaster",
    DOWNLOAD_CSV: "lims/master/investigation_helpmaster/downloadcsv",
  },
  INTERPRETATION: {
    CREATE: "lims/master/create/investigation_ineterpretationmaster",
    LIST: "lims/master/list/investigation_ineterpretationmaster",
    UPDATE: "lims/master/update/investigation_ineterpretationmaster",
    DELETE: "lims/master/delete/investigation_ineterpretationmaster",
    DOWNLOAD_CSV:
      "lims/master/investigation_ineterpretationmaster/downloadcsv",
  },
  DELIVERY_DAYS: {
    CREATE: "lims/master/create/investigation_delivery_daysmaster",
    LIST: "lims/master/list/investigation_delivery_daysmaster",
    // UPDATE: "lims/master/update/investigation_delivery_daysmaster",
    UPDATE:
      "lims/master/update/all_zones/investigation_delivery_daysmaster",
    DELETE: "lims/master/delete/investigation_delivery_daysmaster",
    DOWNLOAD_CSV:
      "lims/master/investigation_delivery_daysmaster/downloadcsv",
  },
  INVESTIGATION_COMMENT: {
    CREATE: "lims/master/create/investigation_commentmaster",
    LIST: "lims/master/list/investigation_commentmaster",
    UPDATE: "lims/master/update/investigation_commentmaster",
    DELETE: "lims/master/delete/investigation_commentmaster",
    DOWNLOAD_CSV: "lims/master/investigation_commentmaster/downloadcsv",
  },
  INVESTIGATIONDETAILS: {
    CREATE: "lims/master/create/investigation_detailmaster",
    LIST: "lims/master/list/investigation_detailmaster",
    UPDATE: "lims/master/update/investigation_detailmaster",
    DELETE: "lims/master/delete/investigation_detailmaster",
    DOWNLOAD_CSV: "lims/master/investigation_detailmaster/downloadcsv",
  },
  DOCTOR: {
    INTERNAL_DOCTOR_LIST: "lims/master/list/doctormaster_dd",
    DOCTOR_ASSIGN_ROLE: "result/reports/get/employee/assign/doctor",
    SIGNATURE_LIST: "lims/master/get/download_doctor_signature",
    CREATE: "lims/master/create/doctormaster",
    LIST: "lims/master/list/doctormaster",
    UPDATE: "lims/master/update/doctormaster",
    DELETE: "lims/master/delete/doctormaster",
    DOWNLOAD_CSV: "lims/master/doctormaster/downloadcsv",
  },
  FRANCHISEDETAILS: {
    CREATE: "hrms/master/create/employeefranchisedetail",
    LIST: "hrms/master/list/employeefranchisedetail",
    DELETE: "hrms/master/delete/employeefranchisedetail",
  },
  EMPLOYEE_ROLES: {
    CREATE: "hrms/master/create/employeeroles",
    EMPLOYEE_WISE_ROLES: "hrms/master/list/employeeroles",
    DELETE: "hrms/master/delete/employeeroles",
  },
  PATIENT: {
    CREATE: "lims/master/create/patientmaster",
    LIST: "lims/master/list/patientmaster",
    UPDATE: "lims/master/update/patientmaster",
    DELETE: "lims/master/delete/patientmaster",
    DOWNLOAD_CSV: "lims/master/patientmaster/downloadcsv",
    DOCUMENTTYPELIST: "lims/master/list/documentmaster",
  },
  APPOINTMENT_PAYMENT: {
    CREATE: "lims/master/create/online_payments_with_detail",
    ORDER_CREATE: "lims/master/create/online_payments_create_order",
    CAPTURE_CREATE: "lims/master/create/capture_online_payment_response",
    LIST: "lims/master/list/patient_appointment_payment_detail",
    // UPDATE: "lims/master/update/patientmaster",
    // DELETE: "lims/master/delete/patientmaster",
    DOWNLOAD_CSV:
      "lims/master/patient_appointment_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "lims/master/list/documentmaster",
  },
  FRANCHISE_ADVANCE_PAYMENT: {
    CREATE: "accounts/master/create/franchiseadvancepaymentmaster",
    ORDER_CREATE: "accounts/master/create/create_advance_online_payments_order",
    PAYU_ORDER_CREATE:
      "accounts/master/create/create_advance_online_payments_order_payu",
    CAPTURE_CREATE:
      "accounts/master/create/capture_advance_online_payment_response",
    LIST: "lims/master/list/patient_appointment_payment_detail",
    // UPDATE: "lims/master/update/patientmaster",
    // DELETE: "lims/master/delete/patientmaster",
    DOWNLOAD_CSV:
      "lims/master/patient_appointment_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "lims/master/list/documentmaster",
  },
  ONLINE_PAYMENT_DETAILS: {
    CREATE: "lims/master/create/online_payments_with_detail",
    ORDER_CREATE: "lims/master/create/online_payments_create_order",
    CAPTURE_CREATE: "lims/master/create/capture_online_payment_response",
    VIEW_LIST: "lims/master/list/online_payment_detail",
    LIST: "lims/master/list/online_payments",
    // UPDATE: "lims/master/update/patientmaster",
    DELETE: "lims/master/delete/online_payment_detail",
    DOWNLOAD_CSV: "lims/master/online_payment_detail/downloadcsv",
    // DOCUMENTTYPELIST: "lims/master/list/documentmaster",
  },
  PANNEL_WISE_BUSISSENES_REPORT: {
    // CREATE: "lims/master/create/documentmaster",
    UPLOADDOCUMENT: "result_entry/upload_patient_investigation_doc",
    CREATEPATIENTLABRESULTENTRY: "result_entry/update_results",
    LIST: "reports/panel/business/report",
    ACCOUNT: "reports/panel/business/account/summary",
    DAILY_SUMMARY: "reports/panel/business/report/daily/summary",
    FRANCHISE_SUPER_FRANCHISE_SUMMARY:
      "reports/panel/bussiness/franchise/summary/report",
    FRANCHISE_SUPER_FRANCHISE_SUMMARY_TWO:
      "reports/panel/business/credit/debit/report",
    //  UPDATE: "lims/master/update/documentmaster",
    DELETE: "lims/master/delete/documentmaster",
    DOWNLOAD_CSV: "lims/master/documentmaster/downloadcsv",
  },
  PAYMENT_TYPE_SEARCH_REPORT: {
    CREATE: "lims/master/create/documentmaster",
    LIST: "reports/payment/type/search/report",
    //  UPDATE: "lims/master/update/documentmaster",
    DELETE: "lims/master/delete/documentmaster",
    DOWNLOAD_CSV: "lims/master/documentmaster/downloadcsv",
  },
  INVESTIGATION_PACKAGE_BOOKING_STATISTICS: {
    LIST: "reports/investigation/package/booking/statistics",
  },
  ANALYTICS_DASHBOARD: {
    LIST: "reports/analytics/dashboard",
  },
  MARKETING_PERSON_PERFORMANCE: {
    LIST: "reports/marketing-person-performance",
  },
  KYC_VERIFICATION: {
    CREATE: "lims/master/create/franchise_kyc_document",
    LIST: "lims/master/list/franchise_kyc_document",
    DELETE: "lims/master/delete/franchise_kyc_document",
    DOWNLOAD_CSV: "lims/master/documentmaster/downloadcsv",
  },
  MACHINE_DATA: {
    CREATE: "lims/master/create/franchise_kyc_document",
    BULK_UPDATE:
      "lims/master/bulk_update/actual_data_received_from_machine",
    BULK_UPDATE_OBSERVATIONS:
      "lims/master/bulkupdate_create_from_machine_data/investigation_observation_host_code",
    LIST: "lims/master/list/actual_data_received_from_machine",
    LIST_BY_BARCODE_ID:
      "lims/master/list/actual_data_received_from_machine",
    LIST_BY_MACHINE_ID_OBSERVATIONS:
      "lims/master/host/code/mapped/observation",
    PENDING_OBSERVATION_LIST: "result_entry/appointment/pending/observation",
    DELETE: "lims/master/delete/franchise_kyc_document",
    DOWNLOAD_CSV: "lims/master/documentmaster/downloadcsv",
  },
  CREATEDEPARTMENT: "hrms/master/create/department",
  CREATEBRANCH: "hrms/master/create/branch",
  STATEBYCOUNTRY: "lims/get_state/",
  CITYBYSTATE: "lims/get_city/",
  ZONELIST: "lims/zone/master",
  CREATEROLE: "hrms/master/create/roles",
  CREATEDESIGNATION: "hrms/master/create/designation",
  GETDEPARTMENT: "hrms/master/list/department",
  PANELTYPEMASTER: "lims/master/create/franchisetypes",
  ADDZONEMASTER: "lims/master/create/zone",
  ADDAREAMASTER: "lims/master/create/areamaster",
  ADDCIRUCLARMASTER: "lims/master/create/circularmaster",
  DISCOUNTMASTER: "lims/master/create/discount_reasonmaster",
  DOCTORMASTER: "lims/master/create/doctor_degreemaster",
  DOCTORSPECIALIZATION: "lims/master/create/doctor_specializationmaster",
  BRANCHLISTING: "hrms/master/list/branch/",
  DELETEBRANCH: "hrms/master/delete/branch/",
  CREATENEWREGISTRATION: "lims/new/registration",
  UPLOADDOCUMENT: "lims/master/create/patientdocument",
  UPDATEUPLOADDOCUMENT: "lims/master/update/patientdocument",
  CHECKNEWREGISTRATION: "lims/new/registration/check",

  OBSERVATION: {
    CREATE: "lims/master/create/observationmaster",
    LIST: "lims/master/list/observationmaster",
    LISTRANGE: "lims/master/list/observationrange",
    UPDATE: "lims/master/update/observationmaster",
    DELETE: "lims/master/delete/observationmaster",
    DOWNLOAD_CSV: "lims/master/observationmaster/downloadcsv",
    UPDATERANGE: "lims/master/update/observationrange",
    DELETERANGE: "lims/master/delete/observationrange",
  },
  RESULT_ENTRY_REPORT: {
    // CREATE: "lims/master/create/documentmaster",
    LIST: "result_entry",
    FRANCHISE_PATIENT_REPORT_LIST: "result_entry/patient_report",
    PDF_LIST: "result_entry/generate/report/pdf",
    GENERATE_PDF_MULTIPLES_INVESTIGATION:
      "result_entry/generate/multiple/investigation/report/pdf",
    QRCODE_PDF: "reports/lims/reports",
    PDF_DOWNLOAD_LIST: "result_entry/appointment/generate_report_pdf",
    INVESTIGATION_DOCUMENT_DOWNLOAD:
      "result_entry/upload_patient_investigation_doc",
    VIEW_OBSERVATION_LIST: "lims/new/registration/get_registration_detail",
    VIEW_PATIENT_LIST: "lims/master/list/patientdocument",
    DOWNLOAD_PATIENT_DOCUMENT_LIST:
      "lims/master/patientdocument/download_document",
    RESULT_ENTRY_DOWNLOAD_PATIENT_DOCUMENT_LIST:
      "result_entry/upload_patient_investigation_doc",
    RESULT_ENTRY_DELETE_PATIENT_DOCUMENT:
      "result_entry/delete_patient_investigation_doc",
    OBSERVATION_LIST: "result_entry/get_investigation_observations",
    ONLY_ORGANISM_LIST: "lims/master/list/investigationmaster_dd",
    INVESTIGATION_OBSERVATION_DD_LIST:
      "lims/master/list/investigation_observationmaster_dd",
    INVESTIGATION_OBSERVATION_DD:
      "lims/master/list/investigation_observationmaster_dd",
    GENERATE_PDF: "result_entry/appointment/generate_report_pdf_node",
    MULTIPLE_GENERATE_PDF:
      "result_entry/appointment/multiple/generate_report_pdf_node",
    DOWNLOAD_INVESTIGATION_DOCUMENT_LIST:
      "result_entry/upload_patient_investigation_doc",
    //  UPDATE: "lims/master/update/documentmaster",
    DELETE: "lims/master/delete/documentmaster",
    DOWNLOAD_CSV: "lims/master/documentmaster/downloadcsv",
  },
  COMMISSION_REPORT: {
    CREATE: "lims/master/create/franchise_commission_master",
    LIST: "lims/master/list/franchise_commission_master",
    UPDATE: "lims/master/update/franchise_commission_master/",
    DELETE: "lims/master/delete/franchise_commission_master",
    DOWNLOAD_CSV: "lims/master/franchise_commission_master/downloadcsv",
  },
  FRANCHISE_COMMISSION_DETAIL: {
    CREATE: "lims/master/create/franchise_commission_detail",
    LIST: "lims/master/list/franchise_commission_detail",
    LIST_BY_ID: "lims/master/list/franchise_commission_detail_by_id",
  },
  HEADER_FOOTER: {
    CREATE: "lims/master/create/report_header_footer",
    LIST: "lims/master/list/report_header_footer",
    DELETE: "lims/master/delete/report_header_footer",
  },
  PROFILE_PICTURE: {
    CREATE: "hrms/master/create/employee_profile_picture",
    LIST_BY_ID: "hrms/master/employee_profile_picture/download_document",
    DELETE: "hrms/master/delete/employee_profile_picture",
  },
  MACHINE_MASTER: {
    CREATE: "lims/master/create/machinemaster",
    LIST: "lims/master/list/machinemaster",
    LIST_DD: "lims/master/list/machinemaster_dd",
    UPDATE: "lims/master/update/machinemaster",
    DELETE: "lims/master/delete/machinemaster",
    DOWNLOAD_CSV: "lims/master/machinemaster/downloadcsv",
  },
  OBSERVATION_HOST_CODE_MASTER: {
    CREATE: "lims/master/create/investigation_observation_host_code",
    LIST: "lims/master/list/investigation_observation_host_code",
    UPDATE: "lims/master/update/investigation_observation_host_code",
    BULK_UPDATE:
      "lims/master/bulkupdate_create/investigation_observation_host_code",
    DELETE: "lims/master/delete/investigation_observation_host_code",
    DOWNLOAD_CSV:
      "lims/master/investigation_observation_host_code/downloadcsv",
    OBSERVATION_ID_MACHINE_ID:
      "lims/master/list/investigation_observation_host_code_by_observation_id_machine_id",
  },
  REPORT_ROLE: {
    CREATE: "result/reports/create/roles",
    LIST: "result/reports/get/roles",
    UPDATE: "result/reports/update/roles",
    DELETE: "result/reports/delete/roles",
    DOWNLOAD_CSV: "hrms/master/reportrole/downloadcsv",
  },
  ASSIGN_ROLE: {
    CREATE: "result/reports/assign/roles",
    LIST: "result/reports/get/assign/roles",
    LIST_BY_ID: "result/reports/get/employee/assign/roles",
    UPDATE: "result/reports/update/assign/roles",
    DELETE: "result/reports/delete/assigns/role",
    DOWNLOAD_CSV: "result_entry/assign/report/rolesdownloadcsv",
  },
  FIREBASE: {
    UPDATE: "hrms/master/update/employee_notifications",
    CREATE: "hrms/master/reset_firebase_token/employee",
    EMPLOYEE_NOTIFICATION: "hrms/master/employee/send_notification",
    EMPLOYEE_NOTIFICATION_LIST: "hrms/master/list/employee_notification",
    EMPLOYEE_NOTIFICATION_LISTS: "hrms/master/list/employee_notifications",
  },
  EMPLOYEEALLOCATE: {
    CREATE: "hrms/master/create/employee_zone_allocation",
    BULK_CREATE: "hrms/master/bulkcreate/employee_zone_allocation",
    LIST: "hrms/master/list/employee_zone_allocation/zone_dd",
    UPDATE: "hrms/master/update/employeecategorymaster",
    DELETE: "hrms/master/delete/employee_zone_allocation",
    DOWNLOAD_CSV: "hrms/master/employeecategorymaster/downloadcsv",
  },
  PACKAGE_COPY_RATE: {
    CREATE: "lims/master/create/franchise_package_rate",
    BULK_CREATE: "lims/master/bulkcreateupdate/franchise_package_rate",
    BULK_CREATE_ONLY: "lims/master/bulkcreateonly/franchise_package_rate",
    LIST: "lims/master/list/franchise_wise_package_rate_list",
    SYNC: "lims/master/franchisemaster/sync_all_package_to_rate_master",
  },
  VENDOR: {
    CREATE: "inventory/master/create/vendormaster",
    LIST: "inventory/master/list/vendormaster",
    VENDOR_LIST_BY_ID: "inventory/master/list/vendormaster_by_id",
    UPDATE: "inventory/master/update/vendormaster",
    DELETE: "inventory/master/delete/vendormaster",
    DOWNLOAD_CSV: "inventory/master/vendormaster/downloadcsv",
  },
  PRODUCT: {
    CREATE: "inventory/master/create/productmaster",
    LIST: "inventory/master/list/productmaster",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/productmaster",
    DELETE: "inventory/master/delete/productmaster",
    DOWNLOAD_CSV: "inventory/master/productmaster/downloadcsv",
  },
  ATTENDANCE: {
    CREATE: "inventory/master/create/productmaster",
    LIST: "hrms/master/list/loginlog",
    UPDATE: "inventory/master/update/productmaster",
    DELETE: "inventory/master/delete/productmaster",
    DOWNLOAD_CSV: "inventory/master/productmaster/downloadcsv",
  },
  EMPLOYEE_ACTIVITY: {
    CREATE_MARK_LOGIN: "hrms/master/loginlog/mark_login",
    CREATE_MARK_LOGOUT: "hrms/master/loginlog/mark_logout",
  },
  INVENTORY_TERMS_CONDITION: {
    CREATE: "inventory/master/create/terms_condition",
    LIST: "inventory/master/list/terms_condition",
    TERMS_CONDITION_LIST_BY_ID: "inventory/master/list/terms_condition_by_id",
    UPDATE: "inventory/master/update/terms_condition",
    DELETE: "inventory/master/delete/terms_condition",
    DOWNLOAD_CSV: "inventory/master/terms_condition/downloadcsv",
  },
  PURCHASE_ORDER: {
    CREATE: "inventory/master/create/full/purchase_order",
    LIST: "inventory/master/list/purchase_order",
    LIST_BY_ID: "inventory/master/list/purchase_order",
    UPDATE: "inventory/master/update/full_purchase_order",
    APPROVE_UPDATE: "inventory/master/update/approve_purchase_order",
    RECEIVE_UPDATE: "inventory/master/purchase_order/mark_receive_order",
    DELETE: "inventory/master/delete/purchase_order",
    DOWNLOAD_CSV: "inventory/master/purchase_order/downloadcsv",
  },
  STOCKIN: {
    CREATE: "inventory/master/stockin_stockout_inventory/inventory_stockin",
    LIST: "inventory/master/list/stockin_stockout_inventory",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/stockin_stockout_inventory",
    DELETE: "inventory/master/delete/stockin_stockout_inventory",
    DOWNLOAD_CSV: "inventory/master/stockin_stockout_inventory/downloadcsv",
  },
  STOCKOUT: {
    CREATE: "inventory/master/stockin_stockout_inventory/inventory_stockout",
    LIST: "inventory/master/list/stockin_stockout_inventory",
    PRODUCT_LIST_BY_ID: "inventory/master/list/productmaster_by_id",
    UPDATE: "inventory/master/update/stockin_stockout_inventory",
    DELETE: "inventory/master/delete/stockin_stockout_inventory",
    DOWNLOAD_CSV: "inventory/master/stockin_stockout_inventory/downloadcsv",
  },
  EMPLOYEE_LEAVE: {
    CREATE: "hrms/master/create/employee_leaves_application",
    LIST: "hrms/master/list/employee_leaves_application",
    LEAVE_LEDGER_SUMMARY_LIST:
      "hrms/master/list/employee_leaves_ledger_summary",
    LEAVE_HISTORY_LIST: "hrms/master/list/employee_leaves_history",
    LEAVE_HISTORY_BY_ID_LIST: "hrms/master/list/employee_leaves_history",
    LIST_BY_ID: "hrms/master/list/employee_leaves_application",
    UPDATE: "hrms/master/update/employee_leaves_application",
    APPROVE_UPDATE: "inventory/master/update/approve_purchase_order",
    RECEIVE_UPDATE: "inventory/master/purchase_order/mark_receive_order",
    DELETE: "hrms/master/delete/employee_leaves_application",
    DOWNLOAD_CSV: "inventory/master/purchase_order/downloadcsv",
  },
  PAYMENT_LEDGER: {
    LIST: "accounts/payment/ledger/list",
    HISTORY_LIST: "accounts/payment/ledger/history/list",
    REPORT: "accounts/payment/ledger/report",
  },
  COMMISSION_LEDGER: {
    LIST: "accounts/commissions/list",
    HISTORY_LIST: "accounts/commissions/history/list",
    REPORT_LIST: "accounts/commission/monthly/list",
    COMMISSION_LEDGER_CARDS_LIST: "accounts/commission/dashboard",
  },
  CREDIT_TRANSFER: {
    CREATE: "accounts/transfer/credit",
    LIST: "accounts/credit/transfer/list",
  },
  ALERT: {
  UPLOAD_IMAGE: "lims/master/banner/upload-image",
  DOWNLOAD_IMAGE: "lims/master/banner/download-image",
  CREATE: "lims/master/create/banner",
  LIST: "lims/master/list/banner",
  UPDATE: "lims/master/update/banner/",
  DELETE: "lims/master/banner",
},
  AUDIT: {
    LIST: "audit/list/logged-actions",
  },
    PATIENT_APPOINTMENT_CLINICAL_HISTORY: {
    CREATE: "lims/master/create/patientappointmentclinicalhistory",
    LIST: "lims/master/list/patientappointmentclinicalhistory",
    LIST_BY_PATIENT: "lims/master/list/patientappointmentclinicalhistory/",
    UPDATE: "lims/master/update/patientappointmentclinicalhistory/",
    DELETE: "lims/master/delete/patientappointmentclinicalhistory/",
    DOWNLOAD_CSV: "lims/master/patientappointmentclinicalhistory/downloadcsv",
  },
    LIMS_APPOINTMENT_PAYMENT_INVOICE: {
    LIST: "lims/lims-appointment-payment-invoice/list",
    LIST_BY_ID: "lims/lims-appointment-payment-invoice/",
    UPDATE_STATUS: "lims/lims-appointment-payment-invoice/status",
  },
};
